// Единая логика статусов направления (N-017), см. admin-panel/src/utils/referralStatus.js.
export function referralLabel(status, clinicConfirmedAt) {
  if (status === 'primary_done') return 'Дошёл';
  if (status === 'duplicate') return 'Дубль';
  if (status === 'timed_out') return 'Не дошёл';
  if (status === 'inactive') return 'Неактивно';
  if (status === 'active') return clinicConfirmedAt ? 'Подтверждён' : 'Направлен';
  return status;
}

export const REFERRAL_STATUS_DEFS = [
  ['Направлен', 'Вы добавили пациента и привязали к клинике/сети. Ждём ближайшей ночной проверки (данные обновляются не мгновенно).'],
  ['Подтверждён', 'Проверка прошла, оплат до даты привязки не было — направление действует, ждём первой оплаты (срок устанавливает клиника).'],
  ['Дубль', 'У пациента была оплата этой клинике ДО даты привязки — он уже был её клиентом, комиссия по нему не начисляется.'],
  ['Дошёл', 'Пациент оплатил первый визит и закреплён за вами в этой клинике — дальше считаются повторные визиты.'],
  ['Не дошёл', 'Пациент не оплатил ни разу за X дней (устанавливается клиникой) с момента привязки — направление снято, слот в активной базе освободился.'],
];
